var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9998 16.2C12.9763 16.2 16.1998 12.9765 16.1998 9.00005C16.1998 5.0236 12.9763 1.80005 8.9998 1.80005C5.02335 1.80005 1.7998 5.0236 1.7998 9.00005C1.7998 12.9765 5.02335 16.2 8.9998 16.2ZM8.59903 6.4512C8.32286 6.26709 7.96777 6.24993 7.67513 6.40654C7.38249 6.56316 7.1998 6.86813 7.1998 7.20005V10.8001C7.1998 11.132 7.38249 11.4369 7.67513 11.5936C7.96777 11.7502 8.32286 11.733 8.59903 11.5489L11.299 9.7489C11.5494 9.58198 11.6998 9.30097 11.6998 9.00005C11.6998 8.69913 11.5494 8.41812 11.299 8.25121L8.59903 6.4512Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5147662ec42f7176af7f8c765e4fe67a.svg";
export { ForwardRef as ReactComponent };